import React from 'react';
const Dedicatedservers = () => {
  return(
<>
    <div className="bg">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
            <h1 className="fs-1 text-center pt-5">Dedicated Servers</h1>
            <p className="text-center">Dedicated servers are the cornerstone of your IT infrastructure. They are a vital component of any IT solution. Enjoy an environment that is 100% devoted to your business' application and software. Completely customize your server's hardware with the vast array of resources that we provide. Performance, power, and flexibility is just a mouse click away.</p>
            <ul>
                <li>* Provisioning times vary please check the current provisining time link for estimated set up.</li>
                <li>* OS versions that have reached end of life are not offered for new installations.</li>
            </ul>
            <h1 className="fs-1 text-center pt-5">Dedicated Server Plans</h1>
            <p>We offer the best Dedicated Bare-Metal Server hosting for gaming, web, and more! Having dedicated servers is one of the best ways to have a reliable and resourceful network. Your server is fully customizable to fit your requirements. Whether you need to upgrade CPU, RAM, GPU, or Disk configuration, all are available at any time. DDoS Protection Always Included.</p>
            <table className="mt-5 border-table">
                <tr className="color text-center">
                    <th><b>Windows Server 2022/2019/2016, CentOS, Ubuntu, Debian, Fedora</b></th>
                    <th>Dual Xeon E5-2695v4</th>
                    <th>Dual Xeon E5-2695v4</th>
                    <th>Dual Xeon Gold 6148</th>
                    <th>Dual Xeon Gold 6148</th> 
                </tr>
                <tr>
                    <th>monthly fee </th>
                    <td> $299</td> 
                    <td>$399</td> 
                    <td>$499</td> 
                    <td>$599</td> 

                </tr>
                <tr>
                    <th className="w-50">set up </th>
                    <td> free</td> 
                    <td>free</td> 
                    <td>free </td> 
                    <td>free</td> 
                </tr>
                <tr>
                    <th>plan name </th>
                    <td>V69A</td> 
                    <td>V69B</td> 
                    <td>V69C</td> 
                    <td>V69D</td> 
                </tr>
                <tr>
                    <th>*Multiple Data Centers(US,EU)</th>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                </tr>
                <p className="fs-3 mt-5">General hosting features</p>
                <tr>
                    <th>Boot Drive (NVMe)</th>
                    <td> 2TB</td> 
                    <td>2TB</td> 
                    <td>2TB</td> 
                    <td>2TB</td> 

                </tr>
                <tr>
                    <th>Additional Storage Drives (SSD)</th>
                    <td><b>2 x 500GB</b><br/>Raid 1</td> 
                    <td><b>2 x 2TB</b><br/>Raid 1</td> 
                    <td><b>2 x 2TB</b><br/>Raid 1 </td> 
                    <td><b>2 x 2TB</b><br/>Raid 1</td> 
                </tr>
                <tr>
                    <th>cpu</th>
                    <td><b>72 Cores</b></td> 
                    <td><b>72 Cores</b></td> 
                    <td><b>80 Cores</b></td> 
                    <td><b>80 Cores</b></td>
                </tr>
                <tr>
                    <th>ram</th>
                    <td><b>256 GB</b></td> 
                    <td><b>256 GB</b></td> 
                    <td><b>256 GB</b></td> 
                    <td><b>512 GB</b></td> 
                </tr>
                <tr>
                    <th className="w-50">bandwidth </th>
                    <td>Unlimited</td> 
                    <td>Unlimited</td> 
                    <td>Unlimited</td> 
                    <td>Unlimited</td> 
                </tr>
                <tr>
                    <th>static IP</th>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                </tr>
                <tr>
                    <th>Operating System</th>
                    <td>Windows/Linux</td> 
                    <td>Windows/Linux</td> 
                    <td>Windows/Linux</td> 
                    <td>Windows/Linux</td> 
                </tr>
                <tr>
                    <th>Remote Desktop / Root Access</th>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                </tr>
                <p className="fs-3 mt-5">Security</p>
                <tr>
                    <th className="w-50">Firewall</th>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                </tr>
                 <tr>
                    <th className="w-20">Always-On DDoS Protection</th>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                </tr>
                <tr>
                    <th className="w-50">Anti Virus / Anti Spam</th>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                </tr>
                 <tr>
                    <th className="w-50">SSAE 16 SOC 2 Type 2 Compliance</th>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                </tr>
                <p className="fs-3 mt-5">Technical Support</p>
                <tr>
                    <th className="w-50">24 X 7 Helpdesk Support</th>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                </tr>
                 <tr>
                    <th className="w-20">24 X 7 Live Chat Support</th>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                </tr>
                <tr>
                    <th className="w-50">Knowledge Base</th>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                    <td><i class="bi bi-check"></i></td>
                </tr>
            </table>

           <div className="row d-flex justify-content-center">
                <div className="col-md-6 text-center">
                    <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5 w-50  "><a href="Contactform" className='p-5'>Contact Us</a></button>
                </div>
           </div>
            
            <div className="row mt-5">
                <div className="col-md-4">
                    <img src="https://www.ewallhost.com/ewall/assets/site/image/pages/dedicated-server/icons/Fully%20Customizable%20Servers.svg" className="w-100"/>
                </div>
                <div className="col-md-8 mt-5">
                    <p className="fs-2">Fully Customizable Servers</p>
                    <p>When it comes to your dedicated server, you need complete control and unbeatable performance. The affordable dedicated servers at eWallHost will let you enjoy multiple customizable options. With eWallHost's dedicated servers, you get access to dedicated IPs, SAN storage, up to 16GB RAM, and 15TB of bandwidth. This allows you to experience the highest resource allocation, privacy, and control for your website or application.</p>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-md-8 mt-5">
                    <p className="fs-2">Ultra-Fast Dedicated Servers with Solid-State Storage (SSD)</p>
                    <p>The SSDs are much faster than traditional hard disk drives (HDDs), so the speed of websites or applications hosted would be considerably quicker. These fast dedicated servers with SSD can notably impact your business by improving user experience, reducing load time, and increasing productivity. The cost difference between SSDs and traditional HDDs varies. However, as a trusted dedicated server hosting providers, eWallHost offers the most affordable and cheap dedicated server plans without compromising its standard.</p>
                </div>
                <div className="col-md-4">
                    <img src="https://www.ewallhost.com/ewall/assets/site/image/pages/dedicated-server/icons/solid-state-drive.svg" className="w-100"/>
                </div>
            </div>
        </div>
    </div>
</>
    );
};
 
export default Dedicatedservers;